// extracted by mini-css-extract-plugin
export default {"body":"reklama_body__ZnlKl","adv":"reklama_adv__iqKkZ","overlayText":"reklama_overlayText__rQW+g"};